import { render, staticRenderFns } from "./StudentInfo.vue?vue&type=template&id=dd8c0fae&scoped=true&"
import script from "./StudentInfo.vue?vue&type=script&lang=js&"
export * from "./StudentInfo.vue?vue&type=script&lang=js&"
import style0 from "./StudentInfo.vue?vue&type=style&index=0&id=dd8c0fae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd8c0fae",
  null
  
)

export default component.exports